import { usePathname } from 'next/navigation'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { addedProductToCartEvent, useCart, useProductGifts } from '@/entities/cart'
import { fetchProductById } from '@/entities/product'

import { CatalogItemLocation, ProductType } from '@/shared/types/deprecated-types'

export const useInitGlobalAddToCart = () => {
	const pathname = usePathname()
	const dispatch = useDispatch()
	const { addItem } = useCart()
	const { checkOneProductForGifts } = useProductGifts()

	useEffect(() => {
		const addToCart = async (ID: string) => {
			const updateBasket = pathname === `/cart`

			const parsedID = Number(ID)
			const productData = await fetchProductById(parsedID)

			if (productData) {
				const productItem = productData.ITEMS[0]
				const payload = {
					TYPE_PRODUCTS: ProductType.Product,
					ID: productItem.ID,
					KOD: productItem.KOD,
					TITLE: productItem.TITLE,
					SECTION_ID: productItem.SECTION_ID,
					PRICE: productItem.PRICE,
					location: CatalogItemLocation.ProductCard
				}

				// Отправка экшена добавления продукта
				addItem({ ...payload, updateBasket })

				// Проверка и обработка подарков
				const { one } = await checkOneProductForGifts(parsedID)
				dispatch(addedProductToCartEvent({ productId: parsedID, gift: one?.[0] }))
			} else {
				// eslint-disable-next-line no-console
				console.error('Некорректный ID, ожидается число.')
			}
		}

		window.globalAddToCart = addToCart

		return () => {
			delete window.globalAddToCart
		}
	}, [pathname])
}

declare global {
	interface Window {
		globalAddToCart?: (ID: string) => Promise<void>
	}
}
